import React, { useEffect } from "react";
import styles from "./Statements.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Overview from "./Overview";
import Transactions from "./Transactions";

const ShopOrderList = () => {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  return (
    <>
      <div className={styles.section}>
        {/* <Overview className={styles.card} /> */}
        <Transactions />
      </div>
      <TooltipGlodal />
    </>
  );
};

export default ShopOrderList;
